import { useState } from 'react';

export const ContextMenu = ({ items = [], position, onClose, onItemClick }) => {
  const handleItemClick = (e, action) => {
    e.stopPropagation();
    onItemClick(action);
    onClose();
  };

  return (
    <>
      <div className="fixed inset-0 z-40" onClick={onClose} />
      <div
        className="absolute w-auto rounded-md shadow-lg bg-[var(--q3-surface-default)] border border-[var(--q3-stroke-normal)]"
        style={{
          top: `${position.y}px`,
          left: `${position.x}px`,
          zIndex: 1000,
        }}
      >
        <div className="py-1">
          {items.map((item) => (
            <button
              key={item.id}
              onClick={(e) => handleItemClick(e, item.action)}
              className={`flex items-center min-h-14 gap-3 justify-start text-start w-full px-4 py-2 text-sm  cursor-pointer text-[var(--q3-neutral-default)] hover:bg-[var(--${item.hoverBg || 'q3-surface-dimmer'})] c`}
            >
              {item.icon && <item.icon size={24} />}
              {item.label}
            </button>
          ))}
        </div>
      </div>
    </>
  );
};
